import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { barogoNoticeApi } from '@/api/barogo-notice';
import BarogoNotice from '@/entity/BarogoNotice';
import PaginationOutput from '@/helpers/PaginationOutput';
export const barogoNoticeService = {
    async getItemList(param = {
        pageNumber: 1,
        pageSize: '20',
    }) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize);
        const response = await barogoNoticeApi.getItemList(params.build());
        return PaginationOutput.adaptorFactory(response, BarogoNotice);
    },
    async getItem(id) {
        const response = await barogoNoticeApi.getItem(id);
        return new BarogoNotice(response.data.data);
    },
};
